import React from "react";
import PropTypes from "prop-types";

// import hoc
import { withFeature } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";

import { BulkCreate } from "app/vendors/modules/generic/feature/add/subFeatures";

const OperatorBulkCreate = (props) => {
  const {
    // learnMore
    setBanner,
  } = props;
  // return <BulkCreate setBanner={setBanner} learnMore={learnMore} />;
  return <BulkCreate setBanner={setBanner} />;
};

OperatorBulkCreate.propTypes = {
  setBanner: PropTypes.func.isRequired,
  // learnMore: PropTypes.func.isRequired,
};
export default withFeature(OperatorBulkCreate, {
  feature: constant.VENDOR_ADD_CSV,
  // subFeature: constant.VENDOR_ADD_CSV,
});
